import { Card, CardContent } from '../../components/ui/card';
import { ConcessionActionLog } from '../../lib/api';
import { useFormatters } from '../../contexts/PreferencesContext';

interface HistoryTabProps {
  actionLogs: ConcessionActionLog[];
}

export function HistoryTab({ actionLogs }: HistoryTabProps) {
  const { formatDateTime } = useFormatters();

  return (
    <Card>
      <CardContent className="pt-6">
        {actionLogs.length === 0 ? (
          <p className="text-muted-foreground text-center py-4">No history available</p>
        ) : (
          <div className="space-y-4">
            {actionLogs.map((log) => (
              <div key={log.id} className="flex items-start gap-3 p-3 bg-muted/50 rounded-lg">
                <div className="flex-1">
                  <p className="font-medium text-sm">{log.action_description}</p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {/* CR-6510: the legacy Log table reads
                        (When, Company, User, Description). The company is the
                        one that was missing, and it matters on a log both
                        parties read — "Approved by J. Miller" is ambiguous
                        until you know which side she was acting for. */}
                    {log.performed_by_name || 'System'}
                    {log.performed_by_company_name ? ` (${log.performed_by_company_name})` : ''}
                    {' - '}{formatDateTime(log.performed_at)}
                  </p>
                  {log.old_value && log.new_value && (
                    <p className="text-xs text-muted-foreground">
                      Changed from "{log.old_value}" to "{log.new_value}"
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
